import { render, staticRenderFns } from "./PanelLayout.vue?vue&type=template&id=6adef1fd&"
import script from "./PanelLayout.vue?vue&type=script&lang=js&"
export * from "./PanelLayout.vue?vue&type=script&lang=js&"
import style0 from "./PanelLayout.vue?vue&type=style&index=0&id=6adef1fd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports